import {
	forEach,
	some,
	groupBy,
	find,
	filter,
	flatMap
} from "lodash";

import { PIVOT_TYPES } from "constants.js";

class DetailHelper {
	constructor(auth, $logger) {
		this.auth = auth;
		this.$logger = $logger;
	}

	explodePivotedRowsAndAssignLinkKeys(updates, fieldDefinitions, repeatToLinkKeyMap = {}) {
		const hasPivotedRows = this.isDetailPivoted(updates);

		updates = updates.filter((val) => val.hasResultForRuleRun !== false);

		if(hasPivotedRows) {
			updates = updates.filter(val => val.hasFullResult !== false);

			const pivotField = fieldDefinitions && find(fieldDefinitions, field => field.Pivot && field.Pivot !== PIVOT_TYPES.Repeat);
			const groupedValues = groupBy(updates, (update) => update.repeatId);

			forEach(groupedValues, (values, repeatId) => {
				if(values.length === 1 && (pivotField && values[0].FieldId === pivotField.Id)) {
					groupedValues[repeatId] = [];
				}
				else if(repeatId !== undefined && repeatId !== "undefined") {
					//groupedValues[undefined] are static fields - if they exist add them to each detail row
					groupedValues[undefined] && groupedValues[undefined].map(val => {
						groupedValues[repeatId].push({ ...val });
					});

					repeatToLinkKeyMap = this.assignDetailLinkKeys(groupedValues[repeatId], repeatId, repeatToLinkKeyMap);
				}
			});

			const detailGroupedValues = filter(groupedValues, (val, index) => (index !== undefined && index !== "undefined"));

			updates = flatMap(detailGroupedValues, (val) => val);

			//if all pivoted rows are empty, still attempt to save one row with non-pivoting data
			if(updates && updates.length === 0 && groupedValues[undefined] && groupedValues[undefined].length > 0) {
				updates = groupedValues[undefined];
				repeatToLinkKeyMap = this.assignDetailLinkKeys(updates, -1, repeatToLinkKeyMap);
			}
		}
		else {
			repeatToLinkKeyMap = this.assignDetailLinkKeys(updates, -1, repeatToLinkKeyMap);
		}

		return { updates, repeatToLinkKeyMap };
	}

	isDetailPivoted(updates) {
		return some(updates, update => !!update.repeatId);
	}

	assignDetailLinkKeys(rowValues, repeatId, repeatToLinkKeyMap) {
		const linkKey = repeatToLinkKeyMap[repeatId] || this.auth.uuid();

		rowValues.map((update) => {
			update.DetailLinkKey = linkKey;
		});

		return {
			...repeatToLinkKeyMap,
			[repeatId]: linkKey
		};
	}

	clearRepeatIds(values) {
		values.map((update) => {
			if(update.repeatId) {
				delete update.repeatId;
			}
		});
	}

	//dedups details by detailId, replacing earlier details in the array list with later details
	mergeDetails(detailValueArrays) {
		const detailsById = detailValueArrays.reduce((acc, nextArray) => {
			const keyedValArray = groupBy(nextArray, val => (val.DetailId ?? "header"));

			forEach(keyedValArray, (fieldValues, detailId) => {
				if(fieldValues.length === 1 && fieldValues[0].FieldId === undefined) {
					acc[detailId] = [];
				}
				else {
					acc[detailId] = fieldValues;
				}
			});

			return acc;
		}, {});

		const flattened = flatMap(detailsById);

		return flattened;
	}
}

export default angular
	.module("vesl.services.detail-helper", [])
	.service("detailHelper", DetailHelper).name;
